import { Link } from 'react-router-dom'
import logo from '../../assets/images/logo.png'
import { useState, useEffect } from 'react'

export default function Nav() {
  const [navActive, setNavActive] = useState(false)
  const [isSticky, setIsSticky] = useState(false)

  // Handle disabling body scroll when nav is active
  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [navActive])

  // Handle sticky nav with JS
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <nav className={`${isSticky ? 'sticky' : ''} ${navActive ? 'active' : ''}`}>
      <div className="logo">
        <div className="menu" onClick={() => setNavActive(prev => !prev)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <img src={logo} alt="Logo" />
      </div>
      <div className="link">
        <div className="logo-btn-wrapper">
          <img src={logo} alt="Logo" />
          <div className="menu" onClick={() => setNavActive(prev => !prev)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link>expriences</Link></li>
          <li><Link>services</Link></li>
          <li><Link>projects</Link></li>
          <li><Link>blog</Link></li>
        </ul>
      </div>
      <Link to="/contact" className="contactMe btn">contact me</Link>
    </nav>
  )
}
